import classNames from 'classnames'
import * as React from 'react'

import './ModalGridContent.scss'

enum ModalGridContentType {
  TRANSPORT_LIST,
}

interface ModalGridContentProps {
  type: ModalGridContentType
  children?: React.ReactNode | undefined
}

const ModalGridContent: React.FC<ModalGridContentProps> = ({
  type,
  children,
}) => {
  const className = classNames(
    'modal-grid-content',
    type === ModalGridContentType.TRANSPORT_LIST ? 'transport-grid' : '',
  )
  return <div className={className}>{children}</div>
}

export { ModalGridContent, ModalGridContentType }
